import { AccrualDatesTable } from 'components/table/accrual_dates/Table';

const AccrualDates = () => {
    return (
        <>
            <AccrualDatesTable />
        </>
    );
}

export { AccrualDates };